import clsx from "clsx";
import type { IntakeStatus } from "./types";
import { useT } from "../../i18n";

// StatusChip + Chip-Map — VERBATIM aus ProjectIntake.tsx (Zeile 37-64)
// extrahiert. Wird vom Intake-Tab UND von den Kanban-„Ingest"-Karten genutzt.
//
// Hier steht nur noch die FARBE; der Text kommt aus dem Katalog (Muster
// ui/labels.ts). Beide Maps bleiben `Record<IntakeStatus, …>` — ein neuer
// Zustand ohne Farbe ODER ohne Text ist damit ein Compiler-Fehler.

export const STATUS_CHIP: Record<IntakeStatus, string> = {
  raw: "bg-surface-3 text-text-2",
  questions: "bg-fuchsia-100 dark:bg-fuchsia-900/40 text-fuchsia-700 dark:text-fuchsia-300",
  answered: "bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-200",
  planning: "bg-warning-soft text-warning",
  planned: "bg-success-soft text-success",
};

export default function IntakeStatusChip({ status }: { status: IntakeStatus }) {
  const t = useT();
  const texte: Record<IntakeStatus, string> = t.shared.intakeStatus;
  return (
    <span
      className={clsx(
        "inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium shrink-0",
        STATUS_CHIP[status]
      )}
    >
      {texte[status]}
    </span>
  );
}
